import { Link } from "react-router-dom";
import { hotComics } from "@/mocks/comics";

export default function HotComicsGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-light text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>本周热门</h2>
          <p className="text-sm text-foreground-500">千万读者都在追的爆款韩漫，不容错过</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {hotComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block rounded-2xl overflow-hidden bg-background-50 hover:bg-background-100 transition-colors duration-300"
            >
              <div className="relative aspect-[3/4] overflow-hidden rounded-xl mb-4">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫屋热门推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 bg-accent-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  TOP {idx + 1}
                </div>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-1">{comic.title}</h3>
              <p className="text-sm text-foreground-500 mb-3">{comic.author} · {comic.latestChapter}</p>
              <div className={`w-full py-2.5 rounded-full text-sm font-medium text-center transition-all whitespace-nowrap ${idx === 0 ? 'bg-foreground-950 text-white hover:bg-foreground-800' : 'border-2 border-foreground-200 text-foreground-700 hover:border-foreground-400'}`}>
                开始阅读
              </div>
              <div className="flex items-center gap-2 mt-3 flex-wrap">
                {comic.tags.map((tag) => (
                  <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">{tag}</span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}